const knownTypes: { [contentType: string]: string } = {
    "application/pdf": "PDF",
    "application/msword": "Word",
    "application/vnd.ms-word": "Word",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
    "application/vnd.ms-excel": "Excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
    "application/vnd.ms-powerpoint": "PowerPoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PowerPoint",
    "application/zip": "ZIP",
    "text/plain": "Text",
    "text/csv": "CSV",
};

/** Short, human readable description of a file based on its content type. Never uses the file name. */
export function fileTypeLabel(contentType?: string): string {
    if (!contentType) {
        return "";
    }
    const type = contentType.split(";")[0].trim().toLowerCase();
    if (knownTypes[type]) {
        return knownTypes[type];
    }
    const [category, subtype] = type.split("/");
    if (category === "image" || category === "audio" || category === "video") {
        const name = category.charAt(0).toUpperCase() + category.slice(1);
        return subtype ? `${name} (${subtype.replace(/^x-/, "").toUpperCase()})` : name;
    }
    return subtype ? subtype.replace(/^x-/, "").toUpperCase() : type;
}
